export default {
  timeRangeList: {
    ThreeMonths: '3 Tháng',
    SixMonths: '6 Tháng',
    OneYear: '1 Năm',
  },
  topNewHighFooter:
    '*Nhóm vượt đỉnh là nhóm cổ phiếu có giá hôm nay đạt mức giá cao nhất trong vòng %{time}',
  topNewLowFooter:
    '*Nhóm thủng đáy là nhóm cổ phiếu có giá hôm nay đạt mức giá thấp nhất trong vòng %{time}',
};
